/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import {
    bool, node,  string,
} from 'prop-types';
import { useLocation } from 'react-router-dom';
import { getFeatureFlag, getPresentationFamily } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles((theme) => ({
    container: (pageType) => ({
        overflow: pageType ? '' : 'hidden auto',
        '&::-webkit-scrollbar-thumb': {
            background: '#808080', // scroll bar color
            borderRadius: 10,
        },
        '&::-webkit-scrollbar': {
            background: 'transparent',
            width: 8,
        },
        scrollbarColor: '#808080 transparent', // for firefox
        scrollbarWidth: 'thin', // for firefox
        width: pageType ? '100%' : 'auto',
    }),
    containerIE: (pageType) => ({
        '@media screen and (min-width: 768px) and (max-width:1366px)': {
            maxWidth: pageType ? '50%' : 'auto',
        },
    }),
    pdpImageStickyContainer: {
        width: '100%',
        position: 'sticky',
        top: 0,
        '&$facetsSticky': {
            height: 'max-content',
            top: 0,
            maxHeight: 'fit-content',
            overflow: 'inherit',
        },
        '& $contentLeft': {
            maxWidth: '100%',
        },
    },
    facetsSticky: {
        position: 'sticky',
        top: 20,
        '& $filterHeader': {
            background: theme.palette.cms?.white || '#fff',
            zIndex: '9999',
            width: '215px',
            position: 'sticky',
        },
        '& $rootFacetsValueOverflow': {
            overflowY: 'inherit',
            maxHeight: 'inherit',
        },
        maxHeight: '100vh',
        overflow: 'auto',
    },
    facetsFixed: {
        '& $rootFacetsValueOverflow': {
            overflowY: 'inherit',
            maxHeight: 'inherit',
        },
    },
}));

const ScrollbarContainerPDPGrid = ({
    children, isFoodBrand, contentContainerId, type, pdpImageStickyEnabled,
}) => {
    const pageType = type === 'productBase';
    const classes = useStyles(pageType);

    const [scroll, setScroll] = useState(1);
    const location = useLocation();
    const pdpImageSticky = pageType && pdpImageStickyEnabled;
    const isSSR = typeof window !== 'undefined';
    const onScroll = () => {
        if (isSSR && document.querySelector(`#${contentContainerId}`)) {
            const {
                top,
            } = document.querySelector(`#${contentContainerId}`).getBoundingClientRect();
            setScroll(top);
        }
    };

    useEffect(() => {
        if ((typeof document !== 'undefined' && isFoodBrand && type === 'collection') || pdpImageSticky) {
            document.addEventListener('scroll', onScroll);
            if (document.querySelector('#root')) {
                document.querySelector('#root').setAttribute('style', 'overflow: unset');
            }
        }

        return () => {
            if ((typeof document !== 'undefined' && isFoodBrand && type === 'collection') || pdpImageSticky) {
                document.removeEventListener('scroll', onScroll);
                if (document.querySelector('#root')) {
                    document.querySelector('#root').setAttribute('style', 'overflow: hidden');
                }
            }
        };
    }, [location?.pathname]);

    let facetCss = classes.root;
    if (isFoodBrand) {
        if (scroll <= 0) {
            facetCss = classes.facetsSticky;
        } else {
            facetCss = classes.facetsFixed;
        }
    }

    return (
        <div className={`${classes.container}  ${facetCss} ${pdpImageSticky ? classes.pdpImageStickyContainer : ''}`}>
            {children}
        </div>
    );
};
ScrollbarContainerPDPGrid.defaultProps = {
    children: null,
    isFoodBrand: false,
    contentContainerId: '',
    type: '',
    pdpImageStickyEnabled: false,
};

ScrollbarContainerPDPGrid.propTypes = {
    children: node,
    isFoodBrand: bool,
    contentContainerId: string,
    type: string,
    pdpImageStickyEnabled: bool,
};
const mapStateToProps = (state) => ({
    pdpImageStickyEnabled: getFeatureFlag('pdp-image-sticky')(state),
    presentationFamily: getPresentationFamily(state),
});
const enhance = compose(
    connect(mapStateToProps),
);

export default enhance(ScrollbarContainerPDPGrid);
